<template>
  <div class="flex items-center justify-center h-full" v-if="params.paymentId">
    <feather-icon
      v-if="$can('rp.invoices', 'write')"
      class="mr-2 cursor-pointer inline-flex"
      svg-classes="text-primary"
      icon="EditIcon"
      :title="'Изменить платеж'"
      @click="openEdit"
    />
    <feather-icon
      v-if="$can('rp.invoices', 'write')"
      class="inline-flex"
      :class="{'cursor-pointer' : params.isEditable}"
      :svg-classes="{'text-primary': params.isEditable}"
      icon="Trash2Icon"
      :title="params.isEditable ? 'Удалить платеж' : 'Чек распечатан, удаление невозможно'"
      @click="showAlertDelete"
    />
    <div class="flex items-center justify-center h-full" :class="$style.support" v-if="$can('support', 'write')">
      <feather-icon
        class="inline-flex cursor-pointer mr-2"
        svg-classes="text-danger"
        icon="EditIcon"
        title="Сменить ЛС"
        @click="showChangeApartment"
      />
      <feather-icon
        class="inline-flex cursor-pointer"
        svg-classes="text-danger"
        icon="Trash2Icon"
        title="Удалить платеж (безвозвратно)"
        @click="showHardDelete"
      />
    </div>
  </div>
  <div v-else></div>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import Vue             from 'vue';

export default Vue.extend({
  name:    "AgGridActions",
  mixins:  [notifyHttpError],
  methods: {
    openEdit() {
      this.params.openEdit(this.params.payment);
    },
    deletePayment() {
      return this.$http.delete('invoice/' + this.params.paymentId, { params: { buildings_id: this.params.buildingsId } }).then(
        ( { data } ) => {
          if (data === 'success') {
            this.params.deleted();
          } else if (data === 'check already print') {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка при удалении',
              text:  'Чек уже напечатан',
            });
          } else {
            throw new Error();
          }
        },
        this.notifyHttpError,
      );
    },

    showAlertDelete() {
      if (this.params.isEditable) {
        this.$vs.dialog({
          type:       'confirm',
          color:      'danger',
          title:      'Подтверждение',
          text:       `Вы уверены что хотите удалить платеж?`,
          acceptText: 'Да',
          cancelText: 'Нет',
          accept:     this.deletePayment,
        });
      }
    },

    showHardDelete() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       `Вы уверены что хотите удалить платеж? Это действие невозможно отменить!`,
        acceptText: 'Да',
        cancelText: 'Нет',
        accept:     () => {
          const { paymentId, buildingsId } = this.params;
          this.$http.delete(`support/invoice/${paymentId}`, { params: { buildings_id: buildingsId } }).then(
            () => this.params.update(),
            this.notifyHttpError,
          );
        },
      });
    },

    showChangeApartment() {
      this.$modal.open({
        title:          'Сменить лицевой счет',
        size:           'md',
        component:      () => import('@/components/calculated-program/payments/PaymentEditAccountModal'),
        componentProps: { payment: this.params.payment },
      }).result.then(
        () => this.params.update(),
        () => {},
      );
    },
  },
});
</script>

<style lang="scss" module>
.support {
  border-left: 1px solid rgba(#000, .15);
  margin-left: .5em;
  padding-left: .5em;
}
</style>
